// Normalise the API base URL so it always ends with "/api".
// This handles env vars set either as:
//   https://praxisbharwani-backend.vercel.app        (without /api)
//   https://praxisbharwani-backend.vercel.app/api    (with /api)
//   /api                                              (local proxy)
const raw =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  "https://praxisbharwani-backend.vercel.app/api";

export const API_BASE = raw.replace(/\/api\/?$/, "") + "/api";
